import { Globals } from "../CoreApp/Globals";

export function supportmsg() {
  return Globals._stringMgr.supportmsg();
}
